import { qualificationConfig } from 'src/redux/slices/QualificationConfig/Type'

/**
 * @description Returns true if the qualification has a rules that is equal to "pinel"
 * @returns boolean
 */
export const isPinel = (qualification?: qualificationConfig): boolean => {
  if (qualification && qualification.rules) {
    const asPinel = qualification.rules.find(
      (el) => el === 'pinel' || el === 'li2015' || el === 'pli'
    )
    if (asPinel) {
      return true
    }
  }

  return false
}
